import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, Add as AddIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';

import { getNotifications } from '../../data/Notifications/actions';
import tools from "../../../../data/common/tools";

class Notification extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        getNotifications: PropTypes.func.isRequired,
        notifications: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshNotifications();
    }

    refreshNotifications = () => {
        const { getNotifications } = this.props;
        this.setState({ loading: true });
        return getNotifications()
            .catch(err => {
                const message = Translator.translate(`api.message.${err.message}`);
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `notifications/detail/${rowData.id}` });
    };

    navigateToAdd = () => {
        const { history } = this.props;
        return history.push({ pathname: 'notifications/add' });
    };

    renderColumns = memoizeOne(profile => {
        const userRights = profile.getIn(['user_rights', 'fhe'], []);

        return [
            {
                title: Translator.translate('general.table.column.title'),
                name: 'title',
                action: (profile.get('admin') || userRights.includes('notificationDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate('general.showDetail')
                }
            },
            {
                title: Translator.translate('general.table.column.message'),
                name: 'messageFR'
            },
            {
                title: Translator.translate('general.table.column.type'),
                name: 'type'
            },
            {
                title: Translator.translate('general.table.column.priority'),
                name: 'priority'
            },
            {
                title: Translator.translate('general.table.column.startDate'),
                name: 'startDate',
                customSort: tools.sortDate
            },
            {
                title: Translator.translate('general.table.column.endDate'),
                name: 'endDate',
                customSort: tools.sortDate
            }
        ];
    });

    renderData = memoizeOne(notifications => {
        let results = [];

        notifications.map((notification, id) => {
            let text = notification.get('messageFR').replace(/(<([^>]+)>)|(&nbsp;)/gi, '');
            if (text.length >= 50) text = text.slice(0, 50).concat('...');

            results.push({
                id,
                title: notification.get('title'),
                messageFR: text,
                type: Translator.translate(`generic.notification.type.${notification.get('type')}`),
                priority: Translator.translate(`generic.notification.priority.${notification.get('priority')}`),
                startDate: notification.get('startDate'),
                endDate: notification.get('endDate')
            });
        });

        return results;
    });

    renderActions = memoizeOne(profile => {
        const userRights = profile.getIn(['user_rights', 'fhe'], []);

        const actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate('generic.notification.table.globalAction.refresh.tooltip'),
                    onClick: this.refreshNotifications
                }
            ]
        };
        if (profile.get('admin') || userRights.includes('notificationAdd')) {
            actions.toolbar.push({
                icon: AddIcon,
                tooltip: Translator.translate('generic.notification.table.globalAction.add.tooltip'),
                onClick: this.navigateToAdd
            });
        }
        if (profile.get('admin') || userRights.includes('notificationDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate('general.showDetail'),
                onClick: this.navigateToDetail
            });
        }

        return actions;
    });

    render() {
        const { loading } = this.state;
        const { profile, notifications } = this.props;

        return (
            <FHETable
                idTable="notificationList"
                columns={this.renderColumns(profile)}
                data={this.renderData(notifications)}
                actions={this.renderActions(profile)}
                title={Translator.translate('generic.notification.table.title')}
                emptyDataSourceMessage={Translator.translate('generic.notification.table.body.emptyDataSourceMessage')}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user,
        notifications: state.environments.fhe.data.Notifications.get('list'),
        initialized: state.environments.fhe.data.Notifications.get('initialized')
    };
}

const styles = theme => ({
    information: {
        color: theme.palette.rainbow.c007
    },
    warning: {
        color: theme.palette.warning.main
    },
    critical: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getNotifications }, dispatch)
    )(withStyles(styles, { withTheme: true })(Notification))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Notification/index.js